/*
 * Public API Surface of ng-validate-equal
 */

export * from './lib/ng-validate-equal.directive';
export * from './lib/ng-validate-equal.module';